import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
  selector: 'app-next-preview-button',
  templateUrl: './next-preview-button.component.html',
  styleUrls: ['./next-preview-button.component.css'],
})
export class NextPreviewButtonComponent implements OnChanges{
  @Input() limit: any;
  @Input() currentPage: any;
  @Input() totalRecords: any;
  @Input() totalPage: any;

  @Output() next: EventEmitter<void> = new EventEmitter<void>();
  @Output() previous: EventEmitter<void> = new EventEmitter<void>();
  @Output() first: EventEmitter<void> = new EventEmitter<void>();
  @Output() last: EventEmitter<void> = new EventEmitter<void>();
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
  totalPageArr: number[] = [];
  constructor() {
 
  }


  ngOnChanges() {
    console.log(
      this.currentPage,
      this.totalRecords,
      this.totalPage,
      this.limit
    );

    this.totalPageArr = Array(this.totalPage).fill(0).map((x, i) => i + 1);
    console.log(this.totalPageArr)
    
  }

  onNext() {
    this.next.emit();
  }
  getRecordRange(): string {
    if(this.totalRecords>0){
      const start = (this.currentPage - 1) * this.limit + 1;
      const end = Math.min(this.currentPage * this.limit, this.totalRecords);
      console.log("i",this.totalRecords,end)
      return `${start} to ${end}`;
    }else{
      
      const start = (this.currentPage - 1) * this.limit ;
      const end = Math.min(this.currentPage * this.limit, this.totalRecords);
      console.log("e",this.totalRecords,end)
      return `${start} to ${end}`; 
    }
  
  }
  isLastPage(): boolean {
    const totalPages = Math.ceil(this.totalRecords / this.limit);
    return this.currentPage >= totalPages;
  }
  onPrevious() {
    this.previous.emit();
  }
  onFirst() {
    this.currentPage = 1;
     this.first.emit();
  }
  onLast() {
    this.currentPage = this.totalPage;
     this.last.emit();
  }

  onPageClick(page: number) {
    this.pageChange.emit(page);
  }

}
